import { Box, Card, CardContent, CardHeader, Grid } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

interface DndGameDroppableZoneProps extends PropsWithChildren {
  gameId: string;
  categorie: string;
}

export const DndGameDroppableZone: FC<DndGameDroppableZoneProps> = ({
  children,
  categorie,
  gameId,
}) => {
  const { t } = useTranslation();

  return (
    <Grid item>
      <Card sx={{ overflow: "visible", borderRadius: "10px" }}>
        <CardHeader
          title={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component={"img"}
                src={`./img/categories/${gameId}.${categorie}.png`}
                alt=""
                sx={{ height: "2em" }}
              />
              <Box component={"span"} sx={{ margin: "0 1rem" }}>
                {t(`games.${gameId}.${categorie}`)}
              </Box>
            </Box>
          }
          sx={{ borderRadius: "10px 10px 0px 0px" }}
        />
        <CardContent>{children}</CardContent>
      </Card>
    </Grid>
  );
};
